import SvgIcon from "@mui/material/SvgIcon";
import type { SvgIconProps } from "@mui/material/SvgIcon";

/** The Order snapshots page's icon: a receipt with an upload arrow (stroke icon). */
export const OrderSnapshotIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 24 24"
    >
      <path
        d="M11.5 21H5V3l2 1.5L9 3l2 1.5L13 3l2 1.5L17 3v8"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinejoin="round"
      />
      <path
        d="M8 9h6M8 13h5M8 17h3"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
      />
      <path
        d="M18 22v-8M14.5 17.5 18 14l3.5 3.5"
        fill="none"
        stroke="currentColor"
        strokeWidth={2.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};
